export default function JobMapVetorIco() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5454 13.0908C15.3487 13.0908 15.9999 13.742 15.9999 14.5454C15.9999 15.3487 15.3487 15.9999 14.5454 15.9999C13.742 15.9999 13.0908 15.3487 13.0908 14.5454C13.0908 13.742 13.742 13.0908 14.5454 13.0908Z"
        fill="#EBF1F4"
      />
      <path
        d="M5.81783 13.0908C6.62117 13.0908 7.27237 13.742 7.27237 14.5454C7.27237 15.3487 6.62117 15.9999 5.81783 15.9999C5.01448 15.9999 4.36328 15.3487 4.36328 14.5454C4.36328 13.742 5.01448 13.0908 5.81783 13.0908Z"
        fill="#EBF1F4"
      />
      <path
        d="M1.45455 13.0908C2.25789 13.0908 2.90909 13.742 2.90909 14.5454C2.90909 15.3487 2.25789 15.9999 1.45455 15.9999C0.6512 15.9999 -2.69251e-08 15.3487 -1.73453e-08 14.5454C-7.76548e-09 13.742 0.6512 13.0908 1.45455 13.0908Z"
        fill="#EBF1F4"
      />
      <path
        d="M10.1821 13.0908C10.9854 13.0908 11.6366 13.742 11.6366 14.5454C11.6366 15.3487 10.9854 15.9999 10.1821 15.9999C9.37874 15.9999 8.72754 15.3487 8.72754 14.5454C8.72754 13.742 9.37874 13.0908 10.1821 13.0908Z"
        fill="#EBF1F4"
      />
      <path
        d="M10.1821 8.72729C10.9854 8.72729 11.6366 9.3785 11.6366 10.1818C11.6366 10.9852 10.9854 11.6364 10.1821 11.6364C9.37874 11.6364 8.72754 10.9852 8.72754 10.1818C8.72754 9.37849 9.37874 8.72729 10.1821 8.72729Z"
        fill="#EBF1F4"
      />
      <path
        d="M14.5454 4.36353C15.3487 4.36353 15.9999 5.01473 15.9999 5.81807C15.9999 6.62142 15.3487 7.27262 14.5454 7.27262C13.742 7.27262 13.0908 6.62142 13.0908 5.81807C13.0908 5.01473 13.742 4.36353 14.5454 4.36353Z"
        fill="#EBF1F4"
      />
      <path
        d="M10.1821 4.36353C10.9854 4.36353 11.6366 5.01473 11.6366 5.81807C11.6366 6.62142 10.9854 7.27262 10.1821 7.27262C9.37874 7.27262 8.72754 6.62142 8.72754 5.81807C8.72754 5.01473 9.37874 4.36353 10.1821 4.36353Z"
        fill="#EBF1F4"
      />
      <path
        d="M5.81783 8.72729C6.62117 8.72729 7.27237 9.3785 7.27237 10.1818C7.27237 10.9852 6.62117 11.6364 5.81783 11.6364C5.01448 11.6364 4.36328 10.9852 4.36328 10.1818C4.36328 9.37849 5.01448 8.72729 5.81783 8.72729Z"
        fill="#EBF1F4"
      />
      <path
        d="M14.5454 1.73453e-08C15.3487 2.69251e-08 15.9999 0.6512 15.9999 1.45455C15.9999 2.25789 15.3487 2.90909 14.5454 2.90909C13.742 2.90909 13.0908 2.25789 13.0908 1.45455C13.0908 0.6512 13.742 7.76548e-09 14.5454 1.73453e-08Z"
        fill="#EBF1F4"
      />
      <path
        d="M14.5454 8.72729C15.3487 8.72729 15.9999 9.3785 15.9999 10.1818C15.9999 10.9852 15.3487 11.6364 14.5454 11.6364C13.742 11.6364 13.0908 10.9852 13.0908 10.1818C13.0908 9.37849 13.742 8.72729 14.5454 8.72729Z"
        fill="#EBF1F4"
      />
    </svg>
  );
}
